module.exports = __webpack_public_path__ + "img/img6.07e78b38.png";